import { environmentMain } from "../Routes/serverRoutes";

export const environment = {
  production: false,
  network: environmentMain,
  etherscanKey: "EH7DJ1HAGTNI8Q36KQT6E77CDYX36KG27P",
  infuraProjectId: "ece2a3079cb54d0883716a41e515eb44",
  appLocked: false,
};
export const CRYPTOCOMPARE_KEY =
  "e1995a6c15beebbb6b3962646dfa04eea75cc281df311c26d1f0ed243ad4cf65";